<template>
  <c-body>
    <header class="toolbar">
      <div class="l-container">
        <div class="toolbar__group">
          <c-level>
            <template slot="left">
              <span class="toolbar__title">{{this.$route.meta.title}}</span>
            </template>
            <template slot="right">
              <span class="toolbar__title u-h6 u-ml-10" v-show="this.$router.currentRoute.name !== 'ClientSettings'">
                <router-link to='settings' class='u-color-success' style='border-bottom: 1px dotted'>
                  {{this.$router.resolve({name:'ClientSettings'}).route.meta.title}}
                </router-link>
              </span>
              <span class="toolbar__title u-h6 u-ml-10" v-show="this.$router.currentRoute.name !== 'ClientUsers'">
                <router-link to='users' class='u-color-success' style='border-bottom: 1px dotted'>
                  {{this.$router.resolve({name:'ClientUsers'}).route.meta.title}}
                </router-link>
              </span>
              <span class="toolbar__title u-h6 u-ml-10" v-show="this.$router.currentRoute.name !== 'ClientEmailInput'">
                <router-link to='email-input' class='u-color-success' style='border-bottom: 1px dotted'>
                  {{this.$router.resolve({name:'ClientEmailInput'}).route.meta.title}}
                </router-link>
              </span>
              <span class="toolbar__title u-h6 u-ml-10" v-show="this.$router.currentRoute.name !== 'ClientEnvProperties'">
                <router-link to='env-settings' class='u-color-success' style='border-bottom: 1px dotted'>
                  {{this.$router.resolve({name:'ClientEnvProperties'}).route.meta.title}}
                </router-link>
              </span>
            </template>
          </c-level>
        </div>
      </div>
    </header>
    <div class="l-container">
      <c-row >
        <c-col md>
          <c-panel>
            <router-view></router-view>
          </c-panel>
        </c-col>
      </c-row>
    </div>
  </c-body>
</template>
<script>
export default {
  name: 'UserAdmin'
}
</script>



// WEBPACK FOOTER //
// src/components/UserAdmin.vue